var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2822 7.43616L11.3267 5.48061C11.0778 5.23172 11.0067 4.88505 11.1044 4.57394C11.4333 3.57839 11.6111 2.51172 11.6111 1.40061C11.6111 0.911719 12.0111 0.511719 12.5 0.511719H15.6111C16.1 0.511719 16.5 0.911719 16.5 1.40061C16.5 9.74727 9.73556 16.5117 1.38889 16.5117C0.9 16.5117 0.5 16.1117 0.5 15.6228V12.5206C0.5 12.0317 0.9 11.6317 1.38889 11.6317C2.49111 11.6317 3.56667 11.4539 4.56222 11.1251C4.87333 11.0184 5.22889 11.0984 5.46889 11.3384L7.42444 13.2939C9.94 12.0051 12.0022 9.95172 13.2822 7.43616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefono);
export default __webpack_public_path__ + "static/media/telefono.287fb73a58f88f34148922f6c2245559.svg";
export { ForwardRef as ReactComponent };